export default "__VITE_ASSET__kAJmK8L9__"